'use client';

import type { ClassValue } from 'clsx';

import { FilterChipsClearAll } from '@vs-shop/commerce-ui/filterChips';
import { clsxm } from '@vs-shop/utils';
import { useIntl } from 'react-intl';

type Props = {
  onClickAction: () => void;
  className?: ClassValue;
};

export default function ProductsSelectedFilterClearAll({ onClickAction, className }: Props) {
  const intl = useIntl();

  return (
    <FilterChipsClearAll onClick={onClickAction} className={clsxm(className)}>
      {intl.formatMessage({
        id: 'products.selectedFilters.clearAll',
        defaultMessage: 'SMAZAT FILTRY',
      })}
    </FilterChipsClearAll>
  );
}
